import api from "../../../auth/api";

// Services
export const listServices = () => api.get("/services").then((r) => r.data);
export const getService = (id) =>
  api.get(`/services/${id}`).then((r) => r.data);
export const createService = (payload) =>
  api.post("/services", payload).then((r) => r.data);
export const updateService = (id, payload) =>
  api.patch(`/services/${id}`, payload).then((r) => r.data);
export const deleteService = (id) =>
  api.delete(`/services/${id}`).then((r) => r.data);

// Locations
export const listLocations = () => api.get("/locations").then((r) => r.data);
export const getLocation = (id) =>
  api.get(`/locations/${id}`).then((r) => r.data);
export const createLocation = (payload) =>
  api.post("/locations", payload).then((r) => r.data);
export const updateLocation = (id, payload) =>
  api.patch(`/locations/${id}`, payload).then((r) => r.data);
export const deleteLocation = (id) =>
  api.delete(`/locations/${id}`).then((r) => r.data);

// Resources
export const listResources = () => api.get("/resources").then((r) => r.data);
export const getResource = (id) =>
  api.get(`/resources/${id}`).then((r) => r.data);
export const createResource = (payload) =>
  api.post("/resources", payload).then((r) => r.data);
export const updateResource = (id, payload) =>
  api.patch(`/resources/${id}`, payload).then((r) => r.data);
export const deleteResource = (id) =>
  api.delete(`/resources/${id}`).then((r) => r.data);

// Appointment reasons
export const listReasons = () =>
  api.get("/appointment-reasons").then((r) => r.data);
export const createReason = (payload) =>
  api.post("/appointment-reasons", payload).then((r) => r.data);
export const updateReason = (id, payload) =>
  api.patch(`/appointment-reasons/${id}`, payload).then((r) => r.data);
export const deleteReason = (id) =>
  api.delete(`/appointment-reasons/${id}`).then((r) => r.data);

// Schedule rules
export const listScheduleRules = () =>
  api.get("/schedule-rules").then((r) => r.data);
export const createScheduleRule = (payload) =>
  api.post("/schedule-rules", payload).then((r) => r.data);
export const updateScheduleRule = (id, payload) =>
  api.patch(`/schedule-rules/${id}`, payload).then((r) => r.data);
export const deleteScheduleRule = (id) =>
  api.delete(`/schedule-rules/${id}`).then((r) => r.data);

// Blackouts
export const listBlackouts = () =>
  api.get("/schedule-blackouts").then((r) => r.data);
export const createBlackout = (payload) =>
  api.post("/schedule-blackouts", payload).then((r) => r.data);
export const updateBlackout = (id, payload) =>
  api.patch(`/schedule-blackouts/${id}`, payload).then((r) => r.data);
export const deleteBlackout = (id) =>
  api.delete(`/schedule-blackouts/${id}`).then((r) => r.data);

// Config bundle (optional)
export const getConfig = () => api.get("/config").then((r) => r.data);
